module.exports = __webpack_public_path__ + "img/642.6371e9f3.png";